module.exports = __webpack_public_path__ + "static/caveats-speed-73814654d08f5225ca01171950024021.png";